import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
 ChangeDetectionStrategy,
 ChangeDetectorRef,
 Component,
 EventEmitter,
 Inject,
 Input,
 OnInit,
 Output,
 PLATFORM_ID,
 TemplateRef,
 WritableSignal,
 effect,
 inject,
 signal,
} from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoCompleteComponent } from '@shared/components/auto-complete/auto-complete.component';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { AutocompleteDirective } from '@shared/directives/autocomplete.directive';
import { DatepickerDirective } from '@shared/directives/datepicker.directive';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { WebengageService } from '@core/services/webengage.service';
import { MomentService } from '@core/services/moment.service';
import { ExtraPersonCounterComponent } from '../extra-person-counter/extra-person-counter.component';
import { EcolodgeService } from '../../services/ecolodge.service';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { PdpPriceDetailsComponent } from '../pdp-price-details/pdp-price-details.component';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';
import { PdpStickyPriceDetail } from '@core/models/domains/general.model';
import { WINDOW } from '../similar-hotels-card/similar-hotels-card.component';

@Component({
 selector: 'iho-pdp-datepicker',
 standalone: true,
 imports: [
  CommonModule,
  MatInputModule,
  MatTabsModule,
  MatFormFieldModule,
  MatButtonToggleModule,
  DatepickerComponent,
  DatepickerDirective,
  AutoCompleteComponent,
  AutocompleteDirective,
  ExtraPersonCounterComponent,
  SkeletonComponent,
  PdpPriceDetailsComponent,
 ],
 templateUrl: './pdp-datepicker.component.html',
 styleUrls: ['./pdp-datepicker.component.scss'],
})
export class PdpDatepickerComponent implements OnInit {
 datepickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);
 autocompleteService = inject(AutocompleteService);
 webengageService = inject(WebengageService);
 pdpUiService = inject(HotelInfoUiService);
 momentService = inject(MomentService);
 router = inject(Router);
 route = inject(ActivatedRoute);
 EcolodgeService = inject(EcolodgeService);

 showLoadingMobile: WritableSignal<any> = signal(false);
 priceDetails: WritableSignal<PdpStickyPriceDetail> = signal({} as PdpStickyPriceDetail);

 @Output() goToRooms = new EventEmitter<{ startDate: string; endDate: string }>();
 @Output() resetEcolodgeinfo = new EventEmitter<boolean>();
 cdr = inject(ChangeDetectorRef);
 csrStatus: WritableSignal<any> = signal(false);
 toggle: boolean = false;
 @Input() isShow: boolean = false;
 @Output() isShowemit = new EventEmitter<boolean>();
 nights = 0;
 startDate = '';
 endDate = '';
 hotelId = -1;
 isShowAlertCount: boolean = false;
 extraGuestonData = '0';
 fixedGuestCount = '1';
 FixedGuestCount: number = 1;
 ExtraGuestCount: number = 0;
 navigatorVal: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(this.window.navigator.userAgent)
  : undefined;
 changeDestinationInPdpMobile = signal(false);
 ihoExtraPersonPrice = 0;

 constructor(
  @Inject(PLATFORM_ID) private platformId: Object,
  @Inject(WINDOW) private window: Window
 ) {
  effect(() => {
   this.nights = Object.keys(this.pdpUiService.hotelInfo())?.length
    ? this.pdpUiService.hotelInfo().HotelHeader?.Price?.Nights
    : 0;
   const [startDate, endDate] = this.pdpUiService.searchBoxService.getStartAndEndDate();
   this.startDate = startDate;
   this.endDate = endDate;
   this.hotelId = this.pdpUiService.hotelId;
  });

  effect(
   () => {
    if (this.datepickerService._state() && isPlatformBrowser(this.platformId)) {
     this.csrStatus.set(DatepickerComponent);
    }
   },
   { allowSignalWrites: true }
  );

  effect(
   () => {
    if (this.autocompleteService._state() && isPlatformBrowser(this.platformId)) {
     if (this.autocompleteService._selectedItem().id !== this.hotelId)
      this.changeDestinationInPdpMobile.set(true);
    } else {
     this.changeDestinationInPdpMobile.set(false);
    }
   },
   { allowSignalWrites: true }
  );


 }
 ngOnInit(): void {
  // this.getCountDetails(1);
  //  this.getResPriceDetails();
 }

 /*
     - toggle
   */
 setToggle() {

  this.isShowemit.emit(false);
  this.isShow = !this.isShow;
  this.datepickerService.setStartDate(this.datepickerService._startDate());
  this.datepickerService.setEndDate(this.datepickerService._endDate());
 }
 unfocus() {
  (document.querySelector('#autocompleteinput-pdp') as any).blur();
  setTimeout(() => {
   (document.querySelector('#autocompleteinput') as any).focus();
  }, 100);
 }
 isShowToast(event: boolean) {
  this.isShowAlertCount = event;
 }
 setNop(value: { nop: number; fixed: number } | any) {
  this.isShowAlertCount = false;
  this.pdpUiService.FixedGuestCount.set(value.fixed);
  this.pdpUiService.ExtraGuestCount.set(value.nop - value.fixed < 0 ? 0 : value.nop - value.fixed);
  this.FixedGuestCount = value.fixed;
  this.ExtraGuestCount = value.nop - value.fixed < 0 ? 0 : value.nop - value.fixed;
  this.getResPriceDetails(value.nop);
  this.datepickerService.setNop(value.nop);
 }
 /*
     - search
   */
 search() {
  debugger
  try {
    this.webengageService.trackIntrack('Hotel-Search', {
     id: this.autocompleteService._selectedItem().id,
     hotelName: this.autocompleteService._selectedItem().name,
     hotelType: this.autocompleteService._selectedItem().type,
     state: this.autocompleteService._selectedItem().state ?? '',
     numberOfNight: this.pdpUiService.nights,
     isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode ?? '',
     checkInDate: this.momentService.toGergorian(this.datepickerService._startDate()),
     checkOutDate: this.momentService.toGergorian(this.datepickerService._endDate()),
     hotelUrl: this.autocompleteService._selectedItem().link,
    });
  //  this.webengageService.track('Hotel Search', {
  //   hotelName: this.autocompleteService._selectedItem().name,
  //   hotelType: this.autocompleteService._selectedItem().type,
  //   numberOfNight: this.pdpUiService.nights,
  //   checkInDate: this.momentService.toGergorian(this.datepickerService._startDate()),
  //   checkOutDate: this.momentService.toGergorian(this.datepickerService._endDate()),
  //   hotelUrl: this.autocompleteService._selectedItem().link,
  //  });
  } catch {}

  let parameters = {
   id: this.autocompleteService._selectedItem().id,
   type: this.autocompleteService._selectedItem().type,
   link: this.autocompleteService._selectedItem().link,
   name: this.autocompleteService._selectedItem().name,
   state: this.autocompleteService._selectedItem()?.state,
   startDate: this.datepickerService._startDate(),
   endDate: this.datepickerService._endDate(),
   nop: this.datepickerService._nop(),
   isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode,
  };
  // TODO implement this
  this.goToRooms.emit(parameters);
  if (parameters.id !== this.hotelId) {
   if (this.searchBoxService.accommodation() == 'ecolodge') {
    this.resetEcolodgeinfo.emit(true);
   }
   this.searchBoxService.triggerSearch(parameters, false, this.autocompleteService.adCode());
  } else {
   this.router
    .navigate([], {
     queryParams: {
      date: parameters.startDate,
      endDate: parameters.endDate,
     },
     queryParamsHandling: 'merge',
     relativeTo: this.route,
     // fragment: 'rooms',
     preserveFragment: true,
    })
    .finally(() => this.pdpUiService.getRooms());
  }
 }
 getCountDetails(value: number) {
  value = value == 0 ? 1 : value;
  this.fixedGuestCount =
   value > this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount
    ? this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount?.toString()
    : value.toString();
  this.extraGuestonData =
   value > this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount
    ? (value - this.pdpUiService.hotelInfo()?.PersonCapacity.FixedGuestCount).toString()
    : '0';
 }
 getResPriceDetails(value: number) {
  if (this.pdpUiService.hotelInfo().Type === 1) {
   this.calcPriceDetailsForIhoPrividers();
   if (value > this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount) {
    const priceDetails = this.priceDetails();
    const otherDetails = {
      title: `${value - this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount} نفر اضافه`,
      finalPrice:
        this.ihoExtraPersonPrice *
        (value - this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount),
    };
    this.priceDetails.set({
      ...priceDetails,
      finalPrice: priceDetails.finalPrice + otherDetails.finalPrice,
      otherDetails: [...priceDetails.otherDetails, otherDetails],
    });
  }
  } else {
   this.showLoadingMobile.set(true);
   if (!this.datepickerService._endDate()) return;
   let res: any = this.EcolodgeService.getProformaAccommodation(
     this.pdpUiService.hotelInfo().HouseId ? this.pdpUiService.hotelInfo().HouseId  : this.pdpUiService.hosueId.toString() ,
    this.datepickerService._startDate(),
    this.datepickerService._endDate(),
    value > this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount
     ? this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount?.toString()
     : value.toString(),
    value > this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount
     ? (value - this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount).toString()
     : '0',
    this.pdpUiService.hotelInfo()?.Type?.toString()
   );
   res.subscribe((res: any) => {
    this.showLoadingMobile.set(false);
    this.priceDetails.set(res);
    this.pdpUiService.ecolodgTotalPrice.set(res);
   });
  }
 }

 calcPriceDetailsForIhoPrividers() {
  this.showLoadingMobile.set(true);
  const dates = Array.from(this.datepickerService.ecolodgeCalenderDetails() as Map<string, any>);
  const formmatedStartDate = this.datepickerService._startDate().replace(/\/(\d)\b/g, '/0$1');
  const formmatedEndDate = this.datepickerService._endDate().replace(/\/(\d)\b/g, '/0$1');
  this.ihoExtraPersonPrice = 0;
  let foundedRange = false
  const priceDetails: PdpStickyPriceDetail = {
   dayPriceDetails: [],
   finalPrice: 0,
   otherDetails: [],
  };

  for (const item of dates) {
   const date = item[0].replace(/\/(\d)\b/g, '/0$1');
   const data = item[1];

   if (date == formmatedStartDate) {
    foundedRange = true
  }

  if (foundedRange) {
    if (date >= formmatedEndDate) {
     break;
    } else {
     if (date >= formmatedStartDate) {
      this.ihoExtraPersonPrice += data.Price.ExtraIho;
      if (data.Price.Iho) {
        priceDetails.finalPrice += data.Price.Iho;
        const duplicateFoundedIndex = priceDetails.dayPriceDetails.findIndex(
         (x: any) => x.unitPrice == data.Price.Iho
        );
        if (duplicateFoundedIndex >= 0) {
         priceDetails.dayPriceDetails[duplicateFoundedIndex].count += 1;
         priceDetails.dayPriceDetails[duplicateFoundedIndex].finalPrice += data.Price.Iho;
        } else {
         priceDetails.dayPriceDetails.push({
          count: 1,
          finalPrice: data.Price.Iho,
          unitPrice: data.Price.Iho,
         });
        }
      }
     }
    }
  }


  }

  this.pdpUiService.ecolodgTotalPrice.set(priceDetails);
  this.priceDetails.set(priceDetails);
  this.showLoadingMobile.set(false);
 }

 searchEcolodge() {
  if (this.datepickerService._nop() == 0) {
   this.isShowAlertCount = true;
   return;
  }
  let parameters = {
   id: this.autocompleteService._selectedItem().id,
   type: this.autocompleteService._selectedItem().type,
   link: this.autocompleteService._selectedItem().link,
   name: this.autocompleteService._selectedItem().name,
   state: this.autocompleteService._selectedItem()?.state,
   startDate: this.datepickerService._startDate(),
   endDate: this.datepickerService._endDate(),
   nop: this.datepickerService._nop(),
   isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode,
  };
  this.goToRooms.emit(parameters);

  if (parameters.id !== this.hotelId)
   this.searchBoxService.triggerSearch(parameters, false, this.autocompleteService.adCode());
  else {
   this.router.navigate([], {
    queryParams: {
     date: parameters.startDate,
     endDate: parameters.endDate,
    },
    queryParamsHandling: 'merge',
    relativeTo: this.route,
    // fragment: 'rooms',
    preserveFragment: true,
   });
  }
   this.isShowemit.emit(false);
   this.isShow = !this.isShow;
 }
}
